import { render, staticRenderFns } from "./VehicleOCR.vue?vue&type=template&id=17f67cf6&scoped=true"
import script from "./VehicleOCR.vue?vue&type=script&lang=js"
export * from "./VehicleOCR.vue?vue&type=script&lang=js"
import style0 from "./VehicleOCR.vue?vue&type=style&index=0&id=17f67cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f67cf6",
  null
  
)

export default component.exports